import { createBuilderModule } from '../../register-builder/builder-module';
import { SplitTreatment } from './SplitTreatment';
import { withChildren } from '@builder.io/react';

export default createBuilderModule(withChildren(SplitTreatment), {
  name: 'SplitTreatment',
  image: 'https://cdn.zappy.app/f2fc45dc1925282215c0a00a39c387bc.png',
  hideFromInsertMenu: true,
  inputs: [
    {
      name: 'treatmentName',
      type: 'string',
      required: true,
      helperText: 'The name of the corresponding treatment in Split.io',
    },
    {
      name: 'isControl',
      type: 'boolean',
      helperText:
        'The control is the treatment that behaves the same as if there was no experiment in place. Every experiment must have a control.',
    },
    {
      name: 'preview',
      type: 'boolean',
      helperText: 'Would you like to see it when in preview/edit mode?',
    },
  ],
});
